module.exports = __webpack_public_path__ + "img/bill.51498b5d.png";